import { message } from "antd";
import { getAppWorkflow, setUsed, update, copy, deleteFlow } from '../services/appList';

const initState = () => {
  return {
    workFlowList: [], // 应用对应工作流列表
    appId: '',
  };
};

export default {
  namespace: 'workflowAppListDetail',

  state: initState(),

  subscriptions: {
    setup({ dispatch, history }) {
      history.listen((props) => {
        const { pathname, query } = props;
        const { appId } = query;
        if (pathname.match(/^\/work[Ff]low\/appList\/detail$/)) {
          dispatch({
            type: 'fetchList',
            payload: { appId },
          });
        }
      });
    },
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {

        const {appId} = payload;
        const data = yield call(getAppWorkflow, { appId });

        yield put({
          type: 'save',
          payload: {
            appId,
            workFlowList: data,
          },
        });
      } catch (error) {
      }
    },
    *fetchRequest({ payload }, { call, put }) {
      try {
        const { requestType, ...params } = payload;

        const configAPI = {
          'setUsed': { api: setUsed, tipText: '设置成功' },
          'update': { api: update, tipText: '设置成功' },
          'copy': { api: copy, tipText: '复制成功' },
          'delete': { api: deleteFlow, tipText: '删除成功' },
        };
        yield call(configAPI[requestType].api, params);

        message.success(configAPI[requestType].tipText);

        yield put({
          type: 'fetchList',
          payload: { appId: params.appId },
        });
        return Promise.resolve();
      } catch (error) {
        return Promise.reject();
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return { ...initState() };
    },
  },
};
